export default "__VITE_ASSET__0e5fa73f__"